import React, { Component } from "react";
import { IonModal, IonHeader, IonToolbar, IonTitle, IonContent, IonSearchbar, IonList, IonItem, IonLabel } from "@ionic/react";
import _ from "lodash";
import { connect } from "react-redux";
import { showLoading, fetchOptions, fetchTimezone, updateTimezone } from "../../redux/actions";
import { colorTheme } from "../../utils/constants";
import { Col, Row } from "reactstrap";

const mapStateToProps = state => {
    return {
        options: state.options,
        timezone: state.timezone
    };
}

const mapDispatchToProps = {
    showLoading,
    fetchOptions,
    updateTimezone,
    fetchTimezone
}

class Timezone extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTimezone: "",
            availableTimezones: [],
            dropdownOpen: false,
            searchTerm: ""
        };

        this.handleTimezonesChange = this.handleTimezonesChange.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
    }

    async fetchInitialData(){
        await Promise.all([
            (
                async () => {
                    if(_.isEmpty(this.props.options)){
                        this.props.showLoading(true);
                        await this.props.fetchOptions();
                    }
                }
            )(),
            (
              async () => {
                  if(_.isEmpty(this.props.timezone)){
                      this.props.showLoading(true);
                      await this.props.fetchTimezone();
                  }
              }
          )()
        ]);
    }

    async componentDidMount() {
        await this.fetchInitialData();
        this.setState({
            selectedTimezone: this.props.timezone.customerTimezone || "Set Timezone",
            availableTimezones: this.props.options.availableTimezones
        });
    }

    async handleTimezonesChange(timezones) {
      await new Promise((resolve) => {
        this.setState(
          {
            selectedTimezone: this.state.availableTimezones.find((t) => t === timezones)
          },
          resolve
        );
      });
      this.props.showLoading(true);
      await this.props.updateTimezone(this.state.selectedTimezone);
    }

    toggleDropdown() {
      this.setState(prevState => ({
          dropdownOpen: !prevState.dropdownOpen
      }));
  }

    render() {
        const { selectedTimezone, availableTimezones, dropdownOpen, searchTerm } = this.state;
        const displaySelected = selectedTimezone || "Set Timezone";
        const filteredTimezones = (availableTimezones || []).filter((t) =>
          String(t || "").toLowerCase().includes(String(searchTerm || "").toLowerCase())
        );

        return (
            <Row className='mx-1 my-2'>
              <Col xs={12} lg={12} className=''>
                <div
                  onClick={() => this.toggleDropdown()}
                  style={{ borderColor: colorTheme["primary"]["700"], border: "2px solid grey", borderRadius: "10px", padding: "12px", cursor: "pointer" }}
                >
                  <span>{displaySelected}</span>
                </div>

                <IonModal isOpen={dropdownOpen} onDidDismiss={() => this.toggleDropdown()}>
                  <IonHeader>
                    <IonToolbar>
                      <IonTitle>Select Timezone</IonTitle>
                    </IonToolbar>
                  </IonHeader>
                  <IonContent>
                    <div className='px-3 py-2'>
                      <IonSearchbar
                        value={searchTerm}
                        debounce={150}
                        placeholder="Search timezone"
                        onIonInput={(e) => this.setState({ searchTerm: e.detail.value })}
                      />
                    </div>
                    <IonList>
                      {filteredTimezones.map((timezone) => (
                        <IonItem
                          key={timezone}
                          button
                          onClick={async () => {
                            await this.handleTimezonesChange(timezone);
                            this.setState({ dropdownOpen: false, searchTerm: "" });
                          }}
                        >
                          <IonLabel>{timezone}</IonLabel>
                        </IonItem>
                      ))}
                    </IonList>
                  </IonContent>
                </IonModal>
              </Col>
          </Row>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Timezone);